import {
  __,
  pipe,
  prop,
  includes,
  map,
  filter,
  pluck,
  sum,
  reduce,
} from "ramda";
import Big from "big.js";
import { writable, derived } from "svelte/store";

const itemActualPrice = pipe(prop("actual_price"), parseFloat);

const calcBalanceItemsTotal = pipe(
  filter(
    pipe(
      prop("type"),
      includes(__, ["GiftCardType", "VoucherType", "ClickCardType"])
    )
  ),
  pluck("balance"),
  map(Big),
  reduce((acc, cur) => acc.add(cur), Big(0)),
  parseFloat
);

export const items = writable([]);

export const orderTotal = derived(
  items,
  ($items) =>
    pipe(
      reduce((acc, cur) => acc.plus(itemActualPrice(cur)), Big(0)),
      parseFloat
    )($items),
  0
);

export const itemsRequiresClickCardsTotal = derived(
  items,
  ($items) =>
    pipe(
      reduce((acc, cur) => {
        if (cur.requires_click_card === true) {
          return acc.add(itemActualPrice(cur));
        }
        return acc;
      }, Big(0)),
      parseFloat
    )($items),
  0
);

export const giftCards = writable([]);

export const vouchers = writable([]);

export const clickCards = writable([]);

export const giftCardsItemsTotal = derived(
  giftCards,
  ($giftCards) => calcBalanceItemsTotal($giftCards),
  0
);
export const voucherItemsTotal = derived(
  vouchers,
  ($vouchers) => calcBalanceItemsTotal($vouchers),
  0
);

export const clickCardsItemsTotal = derived(
  clickCards,
  ($clickCards) => calcBalanceItemsTotal($clickCards),
  0
);

export const balanceItemsTotal = derived(
  [giftCardsItemsTotal, voucherItemsTotal, clickCardsItemsTotal],
  ([$giftCardsItemsTotal, $voucherItemsTotal, $clickCardsItemsTotal]) =>
    parseFloat(
      Big($giftCardsItemsTotal)
        .add($voucherItemsTotal)
        .add($clickCardsItemsTotal)
    ),
  0
);

export const onlinePaymentItemsTotal = derived(
  [
    orderTotal,
    giftCardsItemsTotal,
    voucherItemsTotal,
    itemsRequiresClickCardsTotal,
  ],
  ([
    $orderTotal,
    $giftCardsItemsTotal,
    $voucherItemsTotal,
    $itemsRequiresClickCardsTotal,
  ]) =>
    parseFloat(
      Big($orderTotal)
        .minus($giftCardsItemsTotal)
        .minus($voucherItemsTotal)
        .minus($itemsRequiresClickCardsTotal)
    ),
  0
);

export const requiredQuestionsAnswered = writable(false);

export const submitted = writable(false);

export const acceptLegalTerms = writable(true);

export const useGiftCards = writable(false);
export const useVouchers = writable(false);
export const useClickCards = writable(null);

const withoutGiftCards = derived(useGiftCards, ($giftCards) => !$giftCards);
const withoutVouchers = derived(useVouchers, ($useVouchers) => !$useVouchers);

export const canBuy = derived(
  [requiredQuestionsAnswered, submitted, acceptLegalTerms, useClickCards],
  ([$requiredQuestionsAnswered, $submitted, $legalTerms, $useClickCards]) =>
    $requiredQuestionsAnswered &&
    $submitted === false &&
    $legalTerms === true &&
    $useClickCards !== false,
  false
);

export const canAddToShoppingCart = derived(
  [canBuy, withoutGiftCards, withoutVouchers, useClickCards],
  ([$canBuy, $withoutGiftCards, $withoutVouchers, $useClickCards]) =>
    $canBuy === true &&
    $withoutGiftCards === true &&
    $withoutVouchers === true &&
    $useClickCards === null
);
